//const base_url = 'http://univfosas.des.ticmedia.net';
const base_url = 'https://mapafosasasturias.uniovi.es';

export default base_url; 